import { ENVIRONMENT } from './env.js';
import { isValidUUIDv4 } from './validate.js';

const BaseConstWebappUrl = (() => {
  switch (ENVIRONMENT) {
    case "development": {
      return new URL("http://localhost:3000");
    }
    case "preview":
    case "staging": {
      return new URL(`https://${ENVIRONMENT}.sound.xyz`);
    }
    case "production": {
      return new URL(`https://www.sound.xyz`);
    }
  }
})();
const BaseConstEmbedsUrl = (() => {
  switch (ENVIRONMENT) {
    case "development": {
      return new URL("http://localhost:3010");
    }
    case "preview":
    case "staging": {
      return new URL(`https://${ENVIRONMENT}.embed.sound.xyz`);
    }
    case "production": {
      return new URL(`https://embed.sound.xyz`);
    }
  }
})();
const REFERRAL_ADDRESS_SEARCH_PARAM = "referral";
const REFERRAL_SOURCE_SEARCH_PARAM = "referral_source";
const embedSoundType = "sound";
const embedPrefix = "embed-";
const playlistPrefix = "playlist-";
const linkSource = "link";
function stringifyReferralSource(referralSource) {
  return referralSource.embed ? `${embedPrefix}${referralSource.embed}` : referralSource.playlistId ? `${playlistPrefix}${referralSource.playlistId}` : linkSource;
}
function hasEmbedPrefix(value) {
  return value.startsWith(embedPrefix);
}
function hasPlaylistPrefix(value) {
  return value.startsWith(playlistPrefix);
}
function parseReferralSource(referralSourceParam) {
  if (referralSourceParam === linkSource) {
    return {
      link: true
    };
  } else if (hasEmbedPrefix(referralSourceParam)) {
    const embedType = referralSourceParam.slice(embedPrefix.length);
    if (embedType !== embedSoundType)
      return null;
    return {
      embed: embedSoundType
    };
  } else if (hasPlaylistPrefix(referralSourceParam)) {
    const playlistId = referralSourceParam.slice(playlistPrefix.length);
    if (!playlistId || !isValidUUIDv4(playlistId))
      return null;
    return {
      playlistId
    };
  }
  return null;
}
function WithReferralAddress(url, { referralAddress, source }) {
  const withReferral = new URL(url.toString());
  if (referralAddress) {
    withReferral.searchParams.set(
      REFERRAL_ADDRESS_SEARCH_PARAM,
      referralAddress
    );
  }
  if (source) {
    withReferral.searchParams.set(
      REFERRAL_SOURCE_SEARCH_PARAM,
      stringifyReferralSource(source)
    );
  }
  return withReferral;
}
function ParseUrlWithReferralAddress(url) {
  const possiblyWithReferral = new URL(url.toString());
  const referralAddress = possiblyWithReferral.searchParams.get(
    REFERRAL_ADDRESS_SEARCH_PARAM
  );
  const referralSourceParam = possiblyWithReferral.searchParams.get(
    REFERRAL_SOURCE_SEARCH_PARAM
  );
  const referralSource = referralSourceParam ? parseReferralSource(referralSourceParam) : null;
  return {
    url: possiblyWithReferral,
    referralAddress,
    referralSource
  };
}
function WebappUrl() {
  return new URL(BaseConstWebappUrl.toString());
}
function ReleaseEmbedUrl({
  referral,
  releaseId
}) {
  let baseUrl = new URL(BaseConstEmbedsUrl.toString());
  if (referral) {
    baseUrl = WithReferralAddress(baseUrl, referral);
  }
  baseUrl.pathname = `/v1/release/${releaseId}`;
  return baseUrl;
}
function PlaylistEmbedUrl({
  playlistId,
  theme,
  secret
}) {
  let baseUrl = new URL(BaseConstEmbedsUrl.toString());
  baseUrl.pathname = `${secret ? "/secret" : ""}/v1/playlist/${playlistId}`;
  if (theme) {
    baseUrl.pathname += "/" + theme;
  }
  return baseUrl;
}
function iframeHtml({
  url,
  height,
  style,
  width
}) {
  return `<iframe src="${url.href}" style="${style}" width="${width}" height="${height}" allow="clipboard-write" sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"></iframe>`;
}
function PlaylistIframeEmbed({
  playlistId,
  theme,
  html,
  url = PlaylistEmbedUrl({
    playlistId,
    theme
  })
}) {
  return iframeHtml({
    url,
    ...html
  });
}
function ReleaseIframeEmbed({
  referral,
  releaseId,
  html,
  url = ReleaseEmbedUrl({
    referral,
    releaseId
  })
}) {
  return iframeHtml({
    url,
    ...html
  });
}
function ReleaseWebappUrl({
  releaseTitleSlug,
  artistSoundHandle
}) {
  const url = WebappUrl();
  url.pathname = `/${artistSoundHandle}/${releaseTitleSlug}`;
  return url;
}

export { BaseConstEmbedsUrl, BaseConstWebappUrl, ParseUrlWithReferralAddress, PlaylistEmbedUrl, PlaylistIframeEmbed, REFERRAL_ADDRESS_SEARCH_PARAM, REFERRAL_SOURCE_SEARCH_PARAM, ReleaseEmbedUrl, ReleaseIframeEmbed, ReleaseWebappUrl, WebappUrl, WithReferralAddress, embedSoundType, iframeHtml, parseReferralSource, playlistPrefix, stringifyReferralSource };
